/* nt-chat.js — NatureTech theme-native support chat.
   SSE (Substrate -> Mastra ShopifyAgent) + rich widgets (product cards, chips,
   contact form), page-awareness, and a proactive nudge. All behavior is driven
   by data-* attributes set from the theme-editor settings on #nt-chat. */
(function () {
  // Storage snapshots keep this decision pure and usable without a DOM.
  function shouldShowInvite(state) {
    var kind = state.width > 700 ? 'card' : 'pill';
    var session = state.session || {}, local = state.local || {};
    var closedAt = Number(local.nt_invite_closed_at);
    var reason = state.pageType !== 'product' ? 'not-product'
      : !String(state.product || '').trim() ? 'empty-product'
      : session.nt_invite_shown ? 'already-shown'
      : local.nt_invite_closed_at != null && isFinite(closedAt) && state.now - closedAt < 7 * 24 * 60 * 60 * 1000 ? 'closed-recently'
      : session.nt_overlay_shown ? 'overlay-shown'
      : state.panelOpen ? 'panel-open'
      : state.engaged ? 'engaged'
      : state.elapsedMs < (kind === 'card' ? 45000 : 30000) ? 'too-early'
      : 'ready';
    return { show: reason === 'ready', kind: reason === 'ready' ? kind : null, reason: reason };
  }
  // C-3095: the invitation names a system the way Suzy's mock does ("Homie Smart", not the catalog title "Homie Smart 28").
  // Rule: keep the part before a " - " or " \u2013 " subtitle; drop a trailing model number only after "Smart".
  function inviteName(title) {
    var t = String(title || '').split(/\s[\u2013-]\s/)[0].trim();
    return /\bSmart \d+$/.test(t) ? t.replace(/\s+\d+$/, '') : t;
  }
  // C-3095 (VZ live check): the invitation offers to compare with the OTHER two systems, never the one on this page.
  function otherSystems(title) {
    var all = ['Wally', 'Homie', 'Tobato'], t = String(title || '');
    var mine = all.filter(function (n) { return new RegExp('\\b' + n + '\\b', 'i').test(t); });
    return mine.length === 1 ? all.filter(function (n) { return n !== mine[0]; }).join(' and ') : 'our other systems';
  }
  window.NTChatInvite = { shouldShowInvite: shouldShowInvite, inviteName: inviteName, otherSystems: otherSystems };

  var root = document.getElementById('nt-chat');
  if (!root) return;

  var attr = function (n, d) { var v = root.getAttribute(n); return v == null ? d : v; };
  var on = function (n) { return attr(n, 'true') !== 'false'; }; // default ON unless explicitly "false"
  var CFG = {
    endpoint: attr('data-endpoint', ''),
    shop: attr('data-shop', ''),
    cards: on('data-cards'),
    form: on('data-form'),
    chips: on('data-chips'),
    pageAware: on('data-page-aware'),
    persist: on('data-persist'),
    nudge: on('data-nudge'),
    // C-3045 (Suzy T1): 0 means OFF. The old `|| 25` turned an explicit 0 into a 25 s auto-open.
    nudgeDelay: (function () { var n = parseInt(attr('data-nudge-delay', '25'), 10); return isNaN(n) ? 25 : Math.max(0, n); })(),
    nudgeScroll: Math.max(0, parseInt(attr('data-nudge-scroll', '50'), 10) || 0),
    nudgeText: (attr('data-nudge-text', '') || '').trim(),
    pageType: attr('data-page-type', ''),
    pageTitle: attr('data-page-title', ''),
    product: (attr('data-product', '') || '').trim(),
    productHandle: (attr('data-product-handle', '') || '').trim(),
    url: attr('data-url', '')
  };
  var DEFAULT_WELCOME = "Hi, I'm your NatureTech grow buddy. Ask me about Homie, Wally or Tobato, your order, shipping, or what'll actually thrive on your balcony. I can find products and build your cart too.";

  var bubble = root.querySelector('.nt-chat__bubble');
  var panel = root.querySelector('.nt-chat__panel');
  var closeBtn = root.querySelector('.nt-chat__close');
  var log = root.querySelector('.nt-chat__log');
  var form = root.querySelector('.nt-chat__form');
  var input = root.querySelector('.nt-chat__input');
  var sendBtn = root.querySelector('.nt-chat__send');

  var streaming = false;
  var greeted = false;
  var convId = null;

  // engaged/nudged flags are intentionally per-tab-session (nudge once per visit).
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  // Conversation persistence. When CFG.persist is on we use localStorage (survives
  // browser restarts, ~7-day TTL); otherwise sessionStorage (current tab only).
  var STORE;
  try { STORE = CFG.persist ? window.localStorage : window.sessionStorage; } catch (e) {}
  var PERSIST_MS = 7 * 24 * 60 * 60 * 1000;
  var convo = { cid: null, ts: 0, msgs: [] };
  function loadConvo() {
    try {
      var d = JSON.parse(STORE.getItem('nt_chat_convo') || 'null');
      if (d && d.ts && (Date.now() - d.ts) < PERSIST_MS && Array.isArray(d.msgs)) { convId = d.cid || null; return { cid: d.cid || null, ts: d.ts, msgs: d.msgs }; }
    } catch (e) {}
    return { cid: null, ts: 0, msgs: [] };
  }
  function saveConvo() { convo.cid = convId; convo.ts = Date.now(); if (convo.msgs.length > 40) convo.msgs = convo.msgs.slice(-40); try { STORE.setItem('nt_chat_convo', JSON.stringify(convo)); } catch (e) {} }
  function pushConvo(r, t) { if (!t) return; convo.msgs.push({ r: r, t: t }); saveConvo(); }
  convo = loadConvo();
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(c) { try { return '$' + (Number(c) / 100).toFixed(2); } catch (e) { return ''; } }

  function md(text) {
    var s = esc(text.trim());
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    var lines = s.split(/\n/), out = [], inList = false;
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i], h = ln.match(/^#{1,4}\s+(.*)$/), li = ln.match(/^\s*[-*]\s+(.*)$/);
      if (h) { if (inList) { out.push('</ul>'); inList = false; } out.push('<h3>' + h[1] + '</h3>'); }
      else if (li) { if (!inList) { out.push('<ul>'); inList = true; } out.push('<li>' + li[1] + '</li>'); }
      else { if (inList) { out.push('</ul>'); inList = false; } out.push(ln.trim() ? '<p>' + ln + '</p>' : ''); }
    }
    if (inList) out.push('</ul>');
    return out.join('');
  }

  function statusText(raw) { var m = raw.match(/\[\[STATUS\]\]([\s\S]*?)(?:\[\[\/STATUS\]\]|$)/); return m ? m[1].trim() : ''; }
  function stripWidgets(raw) {
    return raw
      .replace(/\[\[STATUS\]\][\s\S]*?\[\[\/STATUS\]\]/g, '').replace(/\[\[STATUS\]\][\s\S]*$/, '')
      .replace(/\[\[PRODUCT:[^\]]*\]\]/g, '').replace(/\[\[CHIPS:[^\]]*\]\]/g, '').replace(/\[\[CONTACT_FORM\]\]/g, '')
      .replace(/\[\[(?:PRODUCT|CHIPS|CONTACT_FORM|STATUS)[^\]]*$/, '').trim();
  }

  function addMsg(role, html) { var el = document.createElement('div'); el.className = 'nt-chat__msg nt-chat__msg--' + role; el.innerHTML = html; log.appendChild(el); scrollDown(); return el; }
  function addStatus() { var el = document.createElement('div'); el.className = 'nt-chat__status'; el.innerHTML = '<span class="nt-chat__dots"><i></i><i></i><i></i></span><span class="nt-chat__status-txt">Working…</span>'; log.appendChild(el); scrollDown(); return el; }
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  async function renderProductCard(title) {
    if (!CFG.cards) return;
    var card = document.createElement('div');
    card.className = 'nt-chat__card nt-chat__card--loading';
    card.innerHTML = '<div class="nt-chat__card-skel"></div>';
    log.appendChild(card); scrollDown();
    try {
      var sres = await fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources%5Btype%5D=product&resources%5Blimit%5D=1', { headers: { 'Accept': 'application/json' } });
      var sjson = await sres.json();
      var prods = (((sjson.resources || {}).results || {}).products) || [];
      if (!prods.length) { card.remove(); return; }
      var handle = (prods[0].handle || (prods[0].url || '').split('/products/')[1] || '').split('?')[0];
      if (!handle) { card.remove(); return; }
      var p = await (await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })).json();
      var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
      var img = p.featured_image ? (p.featured_image.split('?')[0] + '?width=160') : '';
      card.classList.remove('nt-chat__card--loading');
      card.innerHTML =
        (img ? '<img class="nt-chat__card-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '<div class="nt-chat__card-body">' +
          '<a class="nt-chat__card-title" href="/products/' + esc(handle) + '">' + esc(p.title) + '</a>' +
          '<div class="nt-chat__card-price">' + money(p.price) + (variant && !variant.available ? ' <span class="nt-chat__card-oos">Sold out</span>' : '') + '</div>' +
          '<div class="nt-chat__card-actions">' +
            '<a class="nt-chat__card-view" href="/products/' + esc(handle) + '">View</a>' +
            (variant && variant.available ? '<button type="button" class="nt-chat__card-add" data-vid="' + variant.id + '">Add to cart</button>' : '') +
          '</div></div>';
      var addBtn = card.querySelector('.nt-chat__card-add');
      if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
      scrollDown();
    } catch (e) { card.remove(); }
  }

  async function addToCart(btn) {
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-vid');
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = 'Added ✓'; btn.classList.add('is-added');
      var actions = btn.parentNode;
      if (actions && !actions.querySelector('.nt-chat__card-cart')) { var a = document.createElement('a'); a.className = 'nt-chat__card-cart'; a.href = '/cart'; a.textContent = 'View cart'; actions.appendChild(a); }
      document.dispatchEvent(new CustomEvent('nt:cart:updated'));
    } catch (e) { btn.disabled = false; btn.textContent = 'Add to cart'; }
  }

  function renderChips(options) {
    if (!CFG.chips || !options.length) return;
    var wrap = document.createElement('div'); wrap.className = 'nt-chat__chips';
    options.forEach(function (opt) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'nt-chat__chip'; b.textContent = opt;
      b.addEventListener('click', function () { if (streaming) return; wrap.querySelectorAll('.nt-chat__chip').forEach(function (c) { c.disabled = true; }); submitMessage(opt); });
      wrap.appendChild(b);
    });
    log.appendChild(wrap); scrollDown();
  }

  function renderContactForm() {
    if (!CFG.form || log.querySelector('.nt-chat__cform')) return;
    var f = document.createElement('form'); f.className = 'nt-chat__cform';
    f.innerHTML =
      '<div class="nt-chat__cform-title">Send us a message</div>' +
      '<input name="contact[name]" type="text" placeholder="Your name" required>' +
      '<input name="contact[email]" type="email" placeholder="Email" required>' +
      '<textarea name="contact[body]" rows="3" placeholder="How can we help?" required></textarea>' +
      '<button type="submit">Send</button>';
    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = 'Sending…';
      try { var fd = new FormData(f); fd.append('form_type', 'contact'); fd.append('utf8', '✓'); await fetch('/contact', { method: 'POST', body: fd }); f.innerHTML = '<div class="nt-chat__cform-done">Thanks, we got it. Our team will reach out by email soon.</div>'; }
      catch (err) { btn.disabled = false; btn.textContent = 'Send'; }
    });
    log.appendChild(f); scrollDown();
  }

  function renderWidgets(raw) {
    var re = /\[\[PRODUCT:([^\]]+)\]\]/g, m, titles = [];
    while ((m = re.exec(raw))) { var t = m[1].trim(); if (t && titles.indexOf(t) < 0) titles.push(t); }
    titles.slice(0, 4).forEach(renderProductCard);
    var cm = raw.match(/\[\[CHIPS:([^\]]+)\]\]/);
    if (cm) renderChips(cm[1].split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 5));
    if (/\[\[CONTACT_FORM\]\]/.test(raw)) renderContactForm();
  }

  // ---- nudge -----------------------------------------------------------------
  function nudgeMessage() {
    if (CFG.nudgeText) return CFG.nudgeText.replace(/\{product\}/g, CFG.product || 'our systems');
    if (CFG.product) return "I noticed you're checking out the " + CFG.product + ". Happy to answer any questions, or help you compare it with our other systems. What can I help with?";
    if (CFG.pageType === 'product') return "Looking at one of our systems? I can answer questions or help you pick the right one. What are you growing?";
    return "Hey, I'm right here if you need a hand finding the right setup, or have a question about shipping or an order.";
  }
  function nudgeChips() {
    if (!CFG.chips) return [];
    if (CFG.product) return ['Tell me more about ' + CFG.product, 'Compare your systems', 'Shipping & delivery'];
    return ['Help me choose a system', 'Shipping & delivery', 'Talk to a human'];
  }

  function openPanel(opts) {
    opts = opts || {};
    engagedThisPage = true;
    hideInvite(false);
    ss('nt_chat_engaged', '1');
    root.classList.add('is-open'); panel.hidden = false; bubble.setAttribute('aria-expanded', 'true');
    if (!greeted) {
      greeted = true;
      addMsg('bot', md(opts.nudge ? nudgeMessage() : DEFAULT_WELCOME));
      if (opts.nudge) renderChips(nudgeChips());
    }
    setTimeout(function () { input.focus(); }, 100);
  }
  function closePanel() { root.classList.remove('is-open'); panel.hidden = true; bubble.setAttribute('aria-expanded', 'false'); }

  function scheduleNudge() {
    if (inviteActive) return;
    if (!CFG.nudge) return;
    if (convo.msgs.length) return; // returning chatter already has a conversation
    if (ss('nt_chat_engaged') === '1' || ss('nt_chat_nudged') === '1') return;
    var fired = false;
    var fire = function () {
      if (fired) return; fired = true;
      if (ss('nt_chat_engaged') === '1' || ss('nt_chat_nudged') === '1' || root.classList.contains('is-open')) return;
      ss('nt_chat_nudged', '1');
      openPanel({ nudge: true });
    };
    var t = CFG.nudgeDelay > 0 ? setTimeout(fire, CFG.nudgeDelay * 1000) : null;
    if (CFG.nudgeScroll > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
        if (pct >= CFG.nudgeScroll) { window.removeEventListener('scroll', onScroll); if (t) clearTimeout(t); fire(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  bubble.addEventListener('click', function () { root.classList.contains('is-open') ? closePanel() : openPanel(); });
  closeBtn.addEventListener('click', closePanel);

  // Start a fresh thread: clear the log + stored history and null the conversation
  // id so the agent opens a brand-new Substrate conversation on the next message.
  var newBtn = root.querySelector('.nt-chat__newchat');
  function newThread() {
    if (streaming) return;
    convId = null;
    convo = { cid: null, ts: 0, msgs: [] };
    try { STORE.removeItem('nt_chat_convo'); } catch (e) {}
    log.innerHTML = '';
    greeted = true;
    addMsg('bot', md(DEFAULT_WELCOME));
    input.focus();
  }
  if (newBtn) newBtn.addEventListener('click', newThread);

  function submitMessage(text) { if (!text || streaming) return; addMsg('user', esc(text)); pushConvo('user', text); send(text); }
  form.addEventListener('submit', function (e) { e.preventDefault(); var text = input.value.trim(); if (!text || streaming) return; input.value = ''; submitMessage(text); });

  async function send(message) {
    streaming = true; sendBtn.disabled = true;
    var statusEl = addStatus(), botEl = null, raw = '';
    function render() {
      var clean = stripWidgets(raw), st = statusText(raw);
      if (st && statusEl) statusEl.querySelector('.nt-chat__status-txt').textContent = st;
      if (clean) { if (!botEl) { if (statusEl) { statusEl.remove(); statusEl = null; } botEl = addMsg('bot', ''); } botEl.innerHTML = md(clean); scrollDown(); }
    }
    try {
      var headers = { 'Content-Type': 'application/json', 'x-shopify-shop-url': CFG.shop };
      if (convId) headers['x-shopify-conversation-id'] = convId;
      var body = { message: message, conversation_id: convId };
      if (CFG.pageAware && (CFG.product || CFG.pageType)) {
        body.page_context = { type: CFG.pageType, title: CFG.pageTitle, product: CFG.product, handle: CFG.productHandle, url: CFG.url };
      }
      // Send recent turns (last 8, excluding the just-added current message) so the
      // agent remembers the conversation across pages/sessions. Token-bounded.
      var prior = convo.msgs.slice(0, -1).slice(-8);
      if (prior.length) body.history = prior.map(function (m) { return { role: m.r === 'bot' ? 'assistant' : 'user', content: m.t }; });
      var res = await fetch(CFG.endpoint, { method: 'POST', headers: headers, body: JSON.stringify(body) });
      if (!res.ok || !res.body) throw new Error('http ' + res.status);
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
      while (true) {
        var r = await reader.read(); if (r.done) break;
        buf += dec.decode(r.value, { stream: true });
        var idx;
        while ((idx = buf.indexOf('\n\n')) >= 0) {
          var evt = buf.slice(0, idx); buf = buf.slice(idx + 2);
          evt.split('\n').forEach(function (line) {
            line = line.trim(); if (line.indexOf('data:') !== 0) return;
            var payload = line.slice(5).trim(); if (!payload) return;
            var o; try { o = JSON.parse(payload); } catch (e) { return; }
            if (o.type === 'id' && o.conversation_id) { convId = o.conversation_id; saveConvo(); }
            else if (o.type === 'chunk' && typeof o.chunk === 'string') { raw += o.chunk; render(); }
            else if (o.type === 'error') { raw += '\n\nSorry, something went wrong. Please try again or contact support.'; render(); }
          });
        }
      }
      render();
      var botText = stripWidgets(raw);
      if (!botText && !botEl) { if (statusEl) statusEl.remove(); botText = 'Sorry, I did not catch that. Could you rephrase?'; addMsg('bot', md(botText)); }
      if (botText) pushConvo('bot', botText);
      renderWidgets(raw);
    } catch (err) {
      if (statusEl) statusEl.remove();
      addMsg('bot', md('I am having trouble connecting right now. Please try again in a moment, or email info@nthydroponics.com.'));
    } finally {
      if (statusEl && !botEl) statusEl.remove();
      streaming = false; sendBtn.disabled = false; input.focus();
    }
  }

  // Rehydrate a saved conversation. Panel stays closed (bubble); opening shows history.
  function addBubble(r, t) { var el = document.createElement('div'); el.className = 'nt-chat__msg nt-chat__msg--' + (r === 'bot' ? 'bot' : 'user'); el.innerHTML = (r === 'bot') ? md(t) : esc(t); log.appendChild(el); }
  if (convo.msgs.length) { convo.msgs.forEach(function (m) { addBubble(m.r, m.t); }); greeted = true; scrollDown(); }

  // Product invitations replace the nudge even when suppressed by session state.
  var inviteActive = CFG.pageType === 'product' && !!CFG.product;
  var engagedThisPage = false, invite = null, inviteTimer = null, typingTimer = null;
  var inviteFinished = false, startedAt = Date.now();
  function ls(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  function stopInviteTimer() {
    clearTimeout(inviteTimer);
    window.removeEventListener('resize', scheduleInvite);
  }
  function hideInvite(dismissed) {
    stopInviteTimer();
    clearTimeout(typingTimer);
    inviteFinished = true;
    if (!invite) return;
    if (dismissed) ls('nt_invite_closed_at', String(Date.now()));
    var hadFocus = invite.contains(document.activeElement);
    invite.remove(); invite = null;
    document.removeEventListener('keydown', inviteEscape);
    if (dismissed && hadFocus) bubble.focus();
  }
  function inviteEscape(event) {
    if (event.key === 'Escape' && invite) { event.preventDefault(); hideInvite(true); }
  }
  function showInvite(kind) {
    inviteFinished = true;
    ss('nt_invite_shown', '1');
    ss('nt_overlay_shown', '1');
    invite = document.createElement('div');
    invite.className = 'nt-invite nt-invite--' + kind;
    invite.setAttribute('role', 'dialog');
    invite.setAttribute('aria-label', 'Chat invitation');
    // Use escaped text for product names, including names containing markup.
    var product = esc(inviteName(CFG.product)).replace(/\u2014/g, ',');
    var message = "Hi, I'm Nate! Questions about <b>" + product + '</b>? I can help you check if it fits your space, or compare it with ' + otherSystems(CFG.product) + '.';
    invite.innerHTML = '<button type="button" class="nt-invite__close" aria-label="Close">×</button>' +
      (kind === 'card' ?
        '<button type="button" class="nt-invite__open" aria-label="Chat with Nate">' +
          '<span class="nt-invite__who"><span class="nt-invite__avatar" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="#FFC83D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20c0-6 3-10 8-12-1 6-4 10-8 12z"/><path d="M12 20c0-4-2-7-6-8 0 4 2 7 6 8z"/></svg></span>' +
          '<span><b>Nate</b><span>NatureTech&#39;s AI growing helper</span></span></span>' +
          '<span class="nt-invite__message"><span class="nt-invite__dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
          '<span class="nt-invite__text">' + message + '</span></span></button>' +
          '<div class="nt-invite__chips"><button type="button" data-invite-question="space">Will it fit my space?</button>' +
          '<button type="button" data-invite-question="grow">What can I grow?</button>' +
          '<button type="button" data-invite-question="compare">Compare the systems</button></div>'
        : '<button type="button" class="nt-invite__open"><span class="nt-invite__online" aria-hidden="true"></span>Hi, I&#39;m <b>Nate</b>. Questions about ' + product + '?</button>');
    invite.addEventListener('click', function (event) {
      if (event.target.closest('.nt-invite__close')) { hideInvite(true); return; }
      var chip = event.target.closest('[data-invite-question]');
      var question = chip && { space: 'Will ' + inviteName(CFG.product) + ' fit my balcony?', grow: 'What can I grow on ' + inviteName(CFG.product) + '?', compare: 'Compare the three systems' }[chip.getAttribute('data-invite-question')];
      openPanel();
      if (question) submitMessage(question.replace(/\u2014/g, ','));
    });
    root.appendChild(invite);
    document.addEventListener('keydown', inviteEscape);
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (kind === 'pill' || reduced) invite.classList.add('is-typed');
    else typingTimer = setTimeout(function () { if (invite) invite.classList.add('is-typed'); }, 1300);
  }
  function scheduleInvite() {
    clearTimeout(inviteTimer);
    if (inviteFinished) return;
    var elapsed = window.performance ? window.performance.now() : Date.now() - startedAt;
    var decision = shouldShowInvite({
      pageType: CFG.pageType, product: CFG.product, width: window.innerWidth,
      elapsedMs: elapsed, now: Date.now(),
      session: { nt_invite_shown: ss('nt_invite_shown'), nt_overlay_shown: ss('nt_overlay_shown') },
      local: { nt_invite_closed_at: ls('nt_invite_closed_at') },
      panelOpen: root.classList.contains('is-open'), engaged: engagedThisPage || ss('nt_chat_engaged') === '1'
    });
    if (decision.show) { stopInviteTimer(); showInvite(decision.kind); }
    else if (decision.reason === 'too-early') {
      inviteTimer = setTimeout(scheduleInvite, Math.max(0, (window.innerWidth > 700 ? 45000 : 30000) - elapsed));
    } else { inviteFinished = true; stopInviteTimer(); }
  }
  if (inviteActive) { window.addEventListener('resize', scheduleInvite); scheduleInvite(); }
  scheduleNudge();
})();
